export default __webpack_public_path__ + "static/media/logo_kplus_3.536576b7.svg";